import React from "react";
import BaseComponent from "../base/Base";

export default function BlankPad(margin, className) {
  return (
      <BaseComponent style={{maxHeight: "1px" , marginBottom: "30px"}} className={className}>
      </BaseComponent>
  )
}